/**
 * Audits Page - ComplyIQ
 *
 * Stub page for managing audit engagements.
 */

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { BookOpen, Plus, Search, Filter } from 'lucide-react'

export function AuditsPage() {
  return (
    <div className="space-y-6 animate-fade-in">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-display font-bold">Audits</h2>
          <p className="text-muted-foreground">
            View and manage all audit engagements, schedules, and status
          </p>
        </div>
        <Button>
          <Plus className="h-4 w-4 mr-2" />
          New Audit
        </Button>
      </div>

      {/* Filters */}
      <div className="flex gap-4 flex-wrap">
        <select className="h-10 px-4 rounded-lg border border-border bg-background text-sm">
          <option value="">All Status</option>
          <option value="scheduled">Scheduled</option>
          <option value="in-progress">In Progress</option>
          <option value="completed">Completed</option>
        </select>

        <select className="h-10 px-4 rounded-lg border border-border bg-background text-sm">
          <option value="">All Types</option>
          <option value="internal">Internal</option>
          <option value="external">External</option>
          <option value="certification">Certification</option>
        </select>

        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <input
            type="text"
            placeholder="Search audits..."
            className="w-full h-10 pl-10 pr-4 rounded-lg border border-border bg-background text-sm"
          />
        </div>

        <Button variant="outline">
          <Filter className="h-4 w-4 mr-2" />
          Filters
        </Button>
      </div>

      {/* Audits Table */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <BookOpen className="h-5 w-5" />
            Audits
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-center py-12 text-muted-foreground">
            <BookOpen className="h-12 w-12 mx-auto mb-4 opacity-50" />
            <p className="text-lg font-medium">No audits to display</p>
            <p className="mt-2">
              Audits will appear here after they are available from ComplyIQ.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
